// auth.js

// Cache the token from localStorage at module load
let cachedToken = localStorage.getItem("token") || null;

export const getToken = () => {
  return cachedToken;
};

export const setToken = (newToken) => {
  cachedToken = newToken;
  localStorage.setItem("token", newToken);
};

export const clearToken = () => {
  cachedToken = null;
  localStorage.removeItem("token");
};
